import Ajax from 'js/utils/ajax/ajax.js';

export const newConcern = (concern) => Ajax.post('/shops/v1/concerns', concern);
